import React, { useContext } from 'react';
import classNames from 'classnames';
import { Field } from 'react-final-form';
import InputField from 'components/InputField';
import { useTranslation } from 'react-i18next';
import validations from 'validations';
import HintMessage from 'components/HintMessage';
import ToggleField from 'components/ToggleField';
import PatchListingContext from 'router/subrouters/ListingCreationWizard/providers/PatchListing/PatchListing.context';

import './StatementOfInformation.styles.scss';

type StatementOfInformationProps = {
  className?: string;
};

const StatementOfInformation: React.FC<StatementOfInformationProps> = (
  props,
) => {
  const { className } = props;
  const { t } = useTranslation();

  const classes = classNames('statement-of-information', 'lcw-page', className);

  const { patchListingValue } = useContext(PatchListingContext);

  return (
    <div className={classes}>
      <p className="lcw-page__heading__title">
        {t('statementOfInformation')} {t('(optional)')}
      </p>
      <p className="description">{t('statementInfoOptionalDescription')}</p>
      <HintMessage
        message={
          <div className="statement-of-information__hint-message">
            <p>
              {t('noDetailsOnTheStatementOfInformationIdentifyTheBusiness')}
            </p>
            <p>{t('soiCriteriaMessage')}</p>
            <ul>
              <li>{t('areLoggedIn')}</li>
              <li>{t('haveVerifiedTherAccount')}</li>
              <li>{t('haveEnquiredOnTheListing')}</li>
            </ul>
            <p>
              {t(
                'priceInformationEnablesResolveToMatchListingsToPriceFilteredSearch',
              )}
            </p>
          </div>
        }
      />
      <Field
        name="revenue"
        label={t('revenue')}
        numberStyle="dottedNumber"
        component={InputField}
        placeholder="$"
        validate={validations.positiveNumbersOnly(
          t('onlyPositiveNumbersAreAllowed'),
        )}
        description={t(
          'useEitherTheMostRecentFullCalendarYearFinancialYearOrAverageOfLastTwoYears',
        )}
        parse={(val) => val}
        customOnBlur={(
          e: React.FocusEvent<HTMLInputElement>,
          isValid: boolean,
        ) => {
          if (isValid) {
            patchListingValue({ revenue: e.target.value });
          }
        }}
      />
      <Field
        name="EBITDA"
        label={t('ebitda')}
        numberStyle="dottedNumber"
        component={InputField}
        placeholder="$"
        validate={validations.positiveNumbersOnly(
          t('onlyPositiveNumbersAreAllowed'),
        )}
        description={t(
          'useEitherTheMostRecentFullCalendarYearFinancialYearOrAverageOfLastTwoYears',
        )}
        parse={(val) => val}
        customOnBlur={(
          e: React.FocusEvent<HTMLInputElement>,
          isValid: boolean,
        ) => {
          if (isValid) {
            patchListingValue({ EBITDA: e.target.value });
          }
        }}
      />
      <Field
        name="averageStockValue"
        label={t('averageStockValue')}
        numberStyle="dottedNumber"
        component={InputField}
        placeholder="$"
        validate={validations.positiveNumbersOnly(
          t('onlyPositiveNumbersAreAllowed'),
        )}
        description={t(
          'useEitherTheMostRecentFullCalendarYearFinancialYearOrAverageOfLastTwoYears',
        )}
        parse={(val) => val}
        customOnBlur={(
          e: React.FocusEvent<HTMLInputElement>,
          isValid: boolean,
        ) => {
          if (isValid) {
            patchListingValue({ averageStockValue: e.target.value || null });
          }
        }}
      />

      <Field
        name="purchaseFreeholdCommercialProperty"
        label={t('optionToPurchaseFreeholdCommercialProperty')}
        type="checkbox"
        className="black-toggle"
        component={ToggleField}
        customOnChange={(purchaseFreeholdCommercialProperty: boolean) =>
          patchListingValue({ purchaseFreeholdCommercialProperty })
        }
      />
    </div>
  );
};

export default StatementOfInformation;
